import { Provider as ModalProvider } from "@ebay/nice-modal-react";
import React from "react";
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from "react-redux";
import { RouterProvider } from "react-router-dom";

import "../shared/styles"; // 전역 스타일 적용
import { appRouter } from "./appRouter";
import appStore from "./appStore";

/**
 * 애플리케이션의 진입점을 정의하는 모듈
 * 
 * @module appEntry
 */

/**
 * 애플리케이션의 루트 DOM 요소
 * 모든 React 컴포넌트가 마운트되는 최상위 컨테이너입니다.
 */
const app = document.getElementById('app') as HTMLElement;

/**
 * 애플리케이션을 렌더링합니다.
 * 다음과 같은 Provider들을 포함합니다:
 * - ModalProvider: 모달 관리
 * - ReduxProvider: 상태 관리
 * - RouterProvider: 라우팅 관리
 */
ReactDOM.createRoot(app).render(
    <ModalProvider>
        <ReduxProvider store={appStore}>
            <RouterProvider router={appRouter} />
        </ReduxProvider>
    </ModalProvider>
);